import { ExValLookUp, ExValLookUpKeys } from "./entities";
import { loadLookUp } from "./api";

export function exValLookUpToStateKey( lookup: ExValLookUp ): string {
	if ( ExValLookUpKeys[ lookup ] ) {
		return ExValLookUpKeys[ lookup ];
	}
	return lookup as string;
}

export function populateExValLookup( lookup: ExValLookUp, stateHolder?: any, callback?: ( values?: any ) => void ) {
	loadLookUp( lookup ).then( ( lkpData: any ) => {
		const stateKey = exValLookUpToStateKey( lookup );
		if ( stateHolder ) {
			stateHolder.setState( {
				[ stateKey ]: lkpData,
			} );
		}
		if ( callback ) {
			callback( lkpData );
		}
	} ).catch( ( reason: any ) => {
			if ( callback ) {
				callback( undefined );
			}
		},
	);
}

